import { render, staticRenderFns } from "./countries-selection.vue?vue&type=template&id=ed05617c&"
import script from "./countries-selection.vue?vue&type=script&lang=ts&"
export * from "./countries-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports